var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/DependencyTree/nodes/common/UpdateDialog.tsx";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.map.js";
import * as React from 'react';
import moment from 'moment';
import 'moment/locale/ru';
import { useStore } from 'effector-react';
import { combine } from 'effector';
import { Close } from '@mui/icons-material';
import { IconButton, Toolbar, Button, Table, TableBody, TableCell, TableHead, TableRow, Alert, AlertTitle } from '@mui/material';
import styled from 'styled-components';
import { Dialog } from '@gmini/ui-kit/lib/Dialog';
import { DialogContent } from '@gmini/ui-kit/lib/DialogContent';
import { DialogActions } from '@gmini/ui-kit/lib/DialogActions';
import { DialogTitle } from '@gmini/ui-kit/lib/DialogTitle';
import { Typography } from '@gmini/ui-kit/lib/Typography';
import { Box } from '@gmini/ui-kit/lib/Box';
import { CircularProgress } from '@gmini/ui-kit/lib/CircularProgress';
import { createCountFormatter, isNumber } from '@gmini/utils';
import * as api from '@gmini/sm-api-sdk';
import { resetDiff, useConflicts, useDiff, useVersions } from "../../../Migration";
import { goals } from "../../../../metrika";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var TableHeadCell = styled(TableCell)({
  borderLeft: 'none',
  borderRight: 'none',
  borderTop: 'none'
});
var Ul = styled('ul')({
  marginTop: '5px',
  marginBottom: '5px'
});
var dialogPending$ = combine({
  ɔ: [[api.getBaseClassifierVersionDiff.pending$, api.getUserClassifierMigrationConflicts.pending$, api.getAssemblyClassifierVersionDiff.pending$], function (pendings) {
    return pendings.some(Boolean);
  }],
  config: {
    name: "dialogPending$",
    sid: "-qjza7p"
  }
});
export var UpdateDialog = /*#__PURE__*/React.memo(function (_ref) {
  var modelName = _ref.modelName,
      sourceClassifierId = _ref.sourceClassifierId,
      modelType = _ref.modelType,
      currentClassifier = _ref.currentClassifier,
      onClose = _ref.onClose,
      disabled = _ref.disabled;
  var versions = useVersions(sourceClassifierId);
  var diff = useDiff();
  var conflicts = useConflicts();
  var pending = useStore(dialogPending$, {
    loc: {
      file: _effectorFileName,
      line: 87,
      column: 20
    },
    name: "UpdateDialog",
    sid: "UpdateDialog /src/classifier-editor/DependencyTree/nodes/common/UpdateDialog.tsx [87, 20]"
  });
  var model = diff === null || diff === void 0 ? void 0 : diff.model;
  React.useEffect(function () {
    return resetDiff;
  }, []);
  var onUpdate = React.useCallback(function () {
    goals.confirmUpdatingModelVersion();
    onClose();

    if (!currentClassifier || !versions) {
      return;
    }

    api.migrate.submit({
      classifierId: currentClassifier.id,
      classifierVersion: currentClassifier.version,
      sourceClassifierId: sourceClassifierId,
      currentSourceClassifierVersion: versions.currentVersion,
      newSourceClassifierVersion: versions.latestVersion
    });
  }, [sourceClassifierId, onClose, currentClassifier, versions]);
  React.useEffect(function () {
    if (!versions) {
      return;
    }

    if (modelType === 'AssemblyModel') {
      api.getAssemblyClassifierVersionDiff.submit({
        id: sourceClassifierId,
        versionFrom: versions.currentVersion,
        versionTo: versions.latestVersion
      });
    } else if (modelType === 'ForgeModel') {
      api.getBaseClassifierVersionDiff.submit({
        id: sourceClassifierId,
        versionFrom: versions.currentVersion,
        versionTo: versions.latestVersion
      });
    }

    api.getUserClassifierMigrationConflicts.submit({
      id: currentClassifier.id,
      version: currentClassifier.version,
      sourceClassifierId: sourceClassifierId,
      versionFrom: versions.currentVersion,
      versionTo: versions.latestVersion
    });
  }, [currentClassifier.id, currentClassifier.version, modelType, sourceClassifierId, versions]);

  if (!versions) {
    return null;
  }

  var conflicted = conflicts === null || conflicts === void 0 ? void 0 : conflicts.totalBimElementsConflicted;
  var isAssembly = modelType === 'AssemblyModel';
  return /*#__PURE__*/_jsxs(Dialog, {
    open: true,
    onClick: stopPropagation,
    children: [/*#__PURE__*/_jsx(DialogTitle, {
      children: /*#__PURE__*/_jsxs(Toolbar, {
        disableGutters: true,
        variant: "dense",
        children: [/*#__PURE__*/_jsx(Box, {
          flexGrow: 1,
          children: /*#__PURE__*/_jsxs(Typography, {
            variant: "h6",
            children: ["\u041E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438: ", modelName]
          })
        }), /*#__PURE__*/_jsx(IconButton, {
          onClick: onClose,
          size: "large",
          children: /*#__PURE__*/_jsx(Close, {})
        })]
      })
    }), diff && model && conflicts ? /*#__PURE__*/_jsxs(DialogContent, {
      children: [/*#__PURE__*/_jsxs(Table, {
        size: "small",
        children: [/*#__PURE__*/_jsx(TableHead, {
          children: /*#__PURE__*/_jsxs(TableRow, {
            children: [/*#__PURE__*/_jsx(TableHeadCell, {}), /*#__PURE__*/_jsx(TableHeadCell, {
              children: "\u0422\u0435\u043A\u0443\u0449\u0430\u044F \u0432\u0435\u0440\u0441\u0438\u044F"
            }), /*#__PURE__*/_jsx(TableHeadCell, {
              children: "\u041D\u043E\u0432\u0430\u044F \u0432\u0435\u0440\u0441\u0438\u044F"
            })]
          })
        }), /*#__PURE__*/_jsxs(TableBody, {
          children: [/*#__PURE__*/_jsxs(TableRow, {
            children: [/*#__PURE__*/_jsx(TableCell, {
              children: "\u041D\u043E\u043C\u0435\u0440"
            }), /*#__PURE__*/_jsx(TableCell, {
              children: isAssembly ? diff.classifier.currentVersion : model.currentVersion
            }), /*#__PURE__*/_jsx(TableCell, {
              children: isAssembly ? diff.classifier.latestVersion : model.latestVersion
            })]
          }), /*#__PURE__*/_jsxs(TableRow, {
            children: [/*#__PURE__*/_jsx(TableCell, {
              children: "\u0421\u043E\u0437\u0434\u0430\u043D\u0430"
            }), /*#__PURE__*/_jsx(TableCell, {
              children: formatDateTime(diff.currentVersionTime)
            }), /*#__PURE__*/_jsx(TableCell, {
              children: formatDateTime(diff.latestVersionTime)
            })]
          }), /*#__PURE__*/_jsxs(TableRow, {
            children: [/*#__PURE__*/_jsx(TableCell, {
              children: "\u0410\u0432\u0442\u043E\u0440"
            }), /*#__PURE__*/_jsx(TableCell, {
              children: diff.currentVersionAuthor || 'автор не указан'
            }), /*#__PURE__*/_jsx(TableCell, {
              children: diff.latestVersionAuthor || 'автор не указан'
            })]
          })]
        })]
      }), /*#__PURE__*/_jsx(Box, {
        mt: 3,
        children: "\u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F: "
      }), /*#__PURE__*/_jsx(Ul, {
        children: [// diff.stat.totalBimElementsAdded &&
        "\u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u043E: ".concat(diff.stat.totalBimElementsAdded), // diff.stat.totalBimElementsModified &&
        "\u0438\u0437\u043C\u0435\u043D\u0435\u043D\u043E: ".concat(diff.stat.totalBimElementsModified), // diff.stat.totalBimElementsDeleted &&
        "\u0443\u0434\u0430\u043B\u0435\u043D\u043E: ".concat(diff.stat.totalBimElementsDeleted)] // .filter(Boolean)
        .map(function (text) {
          return /*#__PURE__*/_jsx("li", {
            children: text
          }, text);
        })
      }), isNumber(conflicted) && conflicted > 0 && /*#__PURE__*/_jsx(Box, {
        pt: 2,
        children: /*#__PURE__*/_jsxs(Alert, {
          severity: "warning",
          children: [/*#__PURE__*/_jsx(AlertTitle, {
            children: "\u0412\u043D\u0438\u043C\u0430\u043D\u0438\u0435!"
          }), "\u041F\u0440\u0438 \u043F\u0435\u0440\u0435\u0445\u043E\u0434\u0435 \u043D\u0430 \u043D\u043E\u0432\u0443\u044E \u0432\u0435\u0440\u0441\u0438\u044E \u0438\u0437 \u0432\u0430\u0448\u0435\u0439 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438 \u0431\u0443\u0434\u0435\u0442", ' ', createCountFormatter({
            few: 'удалено',
            one: 'удалён',
            two: 'удалено'
          })(conflicted), ' ', conflicted, ' ', createCountFormatter({
            few: 'элементов',
            one: 'элемент',
            two: 'элемента'
          })(conflicted), ",", ' ', createCountFormatter({
            few: 'которых',
            one: 'которого',
            two: 'которых'
          })(conflicted), ' ', "\u0431\u043E\u043B\u044C\u0448\u0435 \u043D\u0435\u0442 \u0432 \u043C\u043E\u0434\u0435\u043B\u0438."]
        })
      })]
    }) : pending ? /*#__PURE__*/_jsx(Box, {
      display: "flex",
      justifyContent: "center",
      pb: 3,
      pt: 3,
      children: /*#__PURE__*/_jsx(CircularProgress, {
        size: 60
      })
    }) : '', /*#__PURE__*/_jsxs(DialogActions, {
      children: [/*#__PURE__*/_jsx(Button, {
        color: "primary",
        onClick: onUpdate,
        disabled: disabled,
        "data-test-id": "updateModalVersion",
        children: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u043D\u043E\u0432\u0443\u044E \u0432\u0435\u0440\u0441\u0438\u044E"
      }), /*#__PURE__*/_jsx(Button, {
        color: "secondary",
        onClick: onClose,
        children: "\u041E\u0442\u043C\u0435\u043D\u0430"
      })]
    })]
  });
});
UpdateDialog.displayName = 'UpdateDialog';

function stopPropagation(e) {
  e.stopPropagation();
}

export function formatDateTime(time) {
  return moment(time).format('D MMM YYYYг. HH:mm');
}